import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import { BnblSteps } from 'components/OfferPage/BnblModal/utils'

interface Props {
  packageName: string
  setStep: (step: BnblSteps) => void
}

export function BnblPackagePreviewVariant({ packageName, setStep }: Props) {
  const intl = useIntl()
  const onChangePackage = useCallback(() => {
    setStep(BnblSteps.CHANGE_PACKAGE)
  }, [setStep])

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center" gap={24}>
      <BodyText variant="large" weight="bold">{intl.formatMessage({
        id: 'Mhw2Fd7fxLayi9M98vxm',
        defaultMessage: 'Package',
      })}
      </BodyText>
      <TextLink onClick={onChangePackage}>{packageName}</TextLink>
    </Group>
  )
}
